<style lang="scss">
.workshopCard::-webkit-scrollbar {
  display: none;
}
</style>

<template>
  <div ref="cardContainer" class="workshopCard" style="overflow: auto;height: 100%;position: relative;">
    <div class="titleBar" style="padding: 20px;display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding-bottom: 10px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t('shebeijiankong') }}
      </p>
      <div style="display: flex;margin-left: 24px;align-items: center;">
        <div style="display: flex;align-items: center;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: white;"></div>
          <div style="font-size: 14px;font-weight: bold;color: white;margin-left: 4px;">{{ $t('zongshu') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: white;margin-left: 4px;">{{ eqStateNum('0') + eqStateNum('1') + eqStateNum('3') + eqStateNum('-1') }}</div>
        </div>
        <div style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #39F16D;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #39F16D;margin-left: 4px;">{{ $t('yunxing') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: #39F16D;margin-left: 4px;">{{ eqStateNum('0') }}</div>
        </div>
        <div style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #FFC83A;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #FFC83A;margin-left: 4px;">{{ $t('kongxian') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: #FFC83A;margin-left: 4px;">{{ eqStateNum('1') }}</div>
        </div>
        <div style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #FF3A5E;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #FF3A5E;margin-left: 4px;">{{ $t('guzhang') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: #FF3A5E;margin-left: 4px;">{{ eqStateNum('3') }}</div>
        </div>
        <div v-show="monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE == 'moren'" style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #99A0AD;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #99A0AD;margin-left: 4px;">{{ $t('lixian') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: #99A0AD;margin-left: 4px;">
            {{ eqStateNum('-1') }}
          </div>
        </div>
      </div>
    </div>
    <div class="equipments" :style="{ 'grid-template-columns': 'repeat(auto-fill, ' + monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH + 'px)' }" style=";padding:20px;padding-top: 0;display: grid;grid-template-columns:repeat(auto-fill, 176px);grid-row-gap: 7px;grid-column-gap: 7px;">
      <div :style="{ background: cardBgColor(index) }" @click="showEquipment(equipment)" class="equipment" style="background: #121212;width: 100%;cursor: pointer;border-radius: 4px 4px 4px 4px;" v-if="eqState(equipment.id) != '-1' || (eqState(equipment.id) == '-1' && monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE == 'moren')" v-for="(equipment, index) in equipments">
        <div :style="{ background: cardBarColor(index) }" style="width: 100%;;height: 8px;border-radius: 4px 4px 0px 0px;"></div>
        <div style="padding: 12px;">
          <div style="display: flex;justify-content: space-between;">
            <p :style="{ color: cardTextColor(index) }" style="font-size: 24px;word-break: break-all;">{{ equipment.name }}</p>
            <!--  <img v-show="equipmentsPoints[equipment.id]['CurrentState']=='-1'&&equipmentsPoints[equipment.id]['ChannelState']=='0'" style="width: 18px;height: 18px;" :src="cardDisconnectImg(index)" /> -->
          </div>

          <p v-show="false" :style="{ color: cardTextColor(index) }" style="line-height:22px;font-size: 14px;">
            {{ equipment.sn }}
          </p>
          <p v-show="false" v-if="equipmentsPoints[equipment.id]" :style="{ color: cardTextColor(index) }" style="line-height:22px;font-size: 22px;">{{ equipment['modelCode'] }}</p>

          <div v-for="(point, index2) in equipment.boardList">
            <p v-if="point.code == 'ShiftProduct111'" style="color: #F4F4F4;line-height:22px;font-size: 14px;">
              <span>{{ $t(point.i18n) }}</span>&nbsp; <span :style="{ color: cardTextColor(index) }">{{ makePointStr(equipment.id, point) }}</span>&nbsp;
            </p>
            <p v-else style="color: #F4F4F4;line-height:22px;font-size: 14px;word-break:break-all ;" :style="{ 'font-size': monitorSetting.MONITOR_WORKSHOP_CARD_FONT + 'px' }">
              <span v-if="eqState(equipment.id) == '0' || (eqState(equipment.id) !== '0' && monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE == 'moren')">
                <span>{{ $t(point.i18n) }}</span>&nbsp; <span v-if="equipmentsPoints[equipment.id]">{{ makePointStr(equipment.id, point) }}</span>&nbsp;
              </span>
            </p>

            <!-- <span v-if="equipmentsPoints[equipment.id]">{{equipmentsPoints[equipment.id][point.code]?equipmentsPoints[equipment.id][point.code]:equipmentsPoints[equipment.id][point.dmCode]}}</span>&nbsp;
						<span v-if="equipmentsPoints[equipment.id]&&equipmentsPoints[equipment.id][point.code]">{{$t(store.state.eqPoints[equipment.id][point.code]?store.state.eqPoints[equipment.id][point.code].unit:store.state.eqPoints[equipment.id][point.dmCode].unit)}}</span>
					 -->
          </div>
          <!-- {{SET_EQ_POINTS}} -->
          <!-- <p style="color: #F4F4F4;line-height:22px;font-size: 14px;">{{'周期 10s'}}</p>
					<p style="color: #F4F4F4;line-height:22px;font-size: 14px;">{{'模号 KS79S-HA'}}</p>
					<p style="color: #F4F4F4;line-height:22px;font-size: 14px;">{{'计划数量 90000'}}</p>
					<p style="color: #F4F4F4;line-height:22px;font-size: 14px;">{{'计划日期 2021-10-30'}}</p> -->
        </div>
      </div>
    </div>
    <div class="bottomBar" style="width: 100%;height: 20px;position: sticky;bottom: 0;background: #202027;"></div>
  </div>
</template>
<script type="text/javascript">
const execMathExpress = require('exec-mathexpress');
export default {
  name: 'web_monitor_workshop_mes_equipment',
  components: {},

  data() {
    return {
      interval: null,
      isStopListScroll: false,
      timmer: null,
      equipments: [],
      equipmentIds: [],
      equipmentsPoints: {},
      monitorSetting: null
    };
  },
  computed: {
    eqState() {
      return id => {
        if (this.equipmentsPoints[id] == null) {
          return '-1';
        }
        return this.equipmentsPoints[id].CurrentState;
      };
    },
    eqStateNum() {
      return state => {
        let num = 0;
        for (var i = 0; i < this.equipments.length; i++) {
          if (!this.equipmentsPoints[this.equipments[i].id]) {
            if (state == '-1') {
              num++;
            }
            continue;
          }

          if (state == '-1' && this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE != 'moren') {
            continue;
          }

          if (state == this.equipmentsPoints[this.equipments[i].id].CurrentState) {
            num++;
          }
        }
        return num;
      };
    },
    cardBgColor() {
      return index => {
        if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE == 'jianyue') {
          return '#121212';
        } else {
          if (!this.equipmentsPoints[this.equipments[index].id]) {
            //return "linear-gradient(135deg, #404960 0%, #0B0F1F 100%)"
            return '#686869';
          }
          return {
            '0': '#31A84E',
            '1': '#F3992D',
            '3': '#EF3859',
            '-1': '#686869'
            // "0": "linear-gradient(135deg, #AABF26 0%, #0E8444 100%)",
            // "1": "linear-gradient(135deg, #EFC65C 0%, #E2660C 100%)",
            // "3": "linear-gradient(135deg, #D74089 0%, #B8162A 100%)",
            // "-1": "linear-gradient(135deg, #404960 0%, #0B0F1F 100%)",
          }[this.equipmentsPoints[this.equipments[index].id].CurrentState];
        }
      };
    },
    cardBarColor() {
      return index => {
        if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE == 'jianyue') {
          if (!this.equipmentsPoints[this.equipments[index].id]) {
            //return "linear-gradient(90deg, #858FA3 0%, #6A759A 100%)"
            return '#8D85A3';
          }
          return {
            '0': '#39F16D',
            '1': '#FFD057',
            '3': '#FF306E',
            '-1': '#8D85A3'
            // "0": "linear-gradient(135deg, #39F16D 0%, #AABF26 100%)",
            // "1": "linear-gradient(135deg, #E49155 0%, #FFD057 100%)",
            // "3": "linear-gradient(135deg, #FF306E 0%, #E47755 100%)",
            // "-1": "linear-gradient(135deg, #858FA3 0%, #6A759A 100%)",
          }[this.equipmentsPoints[this.equipments[index].id].CurrentState];
        } else {
          return 'none';
        }
      };
    },
    cardTextColor() {
      return index => {
        if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE == 'jianyue') {
          if (!this.equipmentsPoints[this.equipments[index].id]) {
            return '#686869';
          }
          return {
            '0': '#39F16D',
            '1': '#FFC83A',
            '3': '#FF3A5E',
            '-1': '#99A0AD'
          }[this.equipmentsPoints[this.equipments[index].id].CurrentState];
        } else {
          return '#f4f4f4';
        }
      };
    },
    cardDisconnectImg() {
      return index => {
        if (!this.equipmentsPoints[this.equipments[index].id]) {
          return '';
        }
        return {
          '0': require('@@/assets/img/web/workshop/disconnect_green.png'),
          '3': require('@@/assets/img/web/workshop/disconnect_yellow.png'),
          '1': require('@@/assets/img/web/workshop/disconnect_red.png'),
          '-1': require('@@/assets/img/web/workshop/disconnect_gray.png')
        }[this.equipmentsPoints[this.equipments[index].id].CurrentState];
      };
    }
  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getEquipmentMonitorBoard();
    }
  },
  // monitorSetting.MONITOR_WORKSHOP_CARD_STYLE
  created() {
    this.setCardSetting();
    this.getEquipmentMonitorBoard();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('SetCard', () => {
      this.setCardSetting();
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
    this.setCardSetting();
  },
  destroyed() {
    this.utils.event_hub.$off('SetCard');
    clearInterval(this.timmer);
  },
  methods: {
    setAutoScroll(speed = 1) {
      if (this.interval) {
        clearInterval(this.interval);
      }

      const listDiv = this.$refs.cardContainer;
      //防止偏差
      const offset = 1;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          let plus = speed / window.devicePixelRatio;
          if (plus < 1) {
            plus = 1;
          }
          listDiv.scrollTop += plus;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight - offset) {
            console.log('shetrue');
            this.isStopListScroll = true;
            this.monitorSetting.MONITOR_WORKSHOP_CARD_SPEED = speed;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight - offset) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },

    setCardSetting() {
      this.monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING'));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH = 176;
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT = 14;
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE = 'jianyue';
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE = 'moren';
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_SPEED == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_SPEED = 1;
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE = 'moren';
      }
      this.setAutoScroll(this.monitorSetting.MONITOR_WORKSHOP_CARD_SPEED);
    },
    makePointStr(equipmentId, point) {
      if (this.store.state.eqPoints[equipmentId] == null || this.store.state.eqPoints[equipmentId][point.code] == null || this.equipmentsPoints[equipmentId] == null || this.equipmentsPoints[equipmentId][point.code] == null) {
        //不存在值，返回空字符串
        // console.log('空的', equipmentId, point.code)
        return '';
      }
      let str = '';
      if (this.store.state.eqPoints[equipmentId][point.code].dataType == '1') {
        //字符串类型，直接返回
        return this.equipmentsPoints[equipmentId][point.code];
      } else if (this.store.state.eqPoints[equipmentId][point.code].dictTypeCode != null) {
        //字典类型，直接返回字典
        str = this.$t(this.store.state.dictJsonAll[this.store.state.eqPoints[equipmentId][point.code].dictTypeCode][parseInt(this.equipmentsPoints[equipmentId][point.code])]);
      } else {
        str = this.equipmentsPoints[equipmentId][point.code];

        //公式类型都是数字类型，所以要计算小数点位，有配置小数点位则tofixed，没有则不处理
        if (this.store.state.eqPoints[equipmentId][point.code].prec != null) {
          str = parseFloat(str).toFixed(this.store.state.eqPoints[equipmentId][point.code].prec);
        } else {
          str = parseInt(str);
        }
      }
      // 如果值是NAN，显示'-'
      if (isNaN(str)) {
        str = '-';
      } else if (this.store.state.eqPoints[equipmentId][point.code].unit) {
        // 有单位则加上单位
        str += this.store.state.eqPoints[equipmentId][point.code].unit;
      }
      return str;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 800);
    },
    showEquipment(equipment) {
      this.utils.event_hub.$emit('SHOW_WORKSHOP_EQUIPMENT', equipment);
    },
    getEquipmentMonitorBoard() {
      this.http
        .get('web/equipment/getEquipmentMonitorBoard', {
          params: {
            orgId: this.$attrs.orgId
          }
        })
        .then(res => {
          this.equipments = res.data;
          // 筛选出所有设备id
          this.equipmentIds = res.data.map(e => e.id);

          if (this.timmer) {
            clearInterval(this.timmer);
          }
          this.timmer = setInterval(() => {
            this.getMonitorData();
          }, 120000);
          this.getMonitorData();
        });
    },
    getMonitorData() {
      // this.http
      //   .get("web/equipment/getMesMonitorData", {
      //     params: {
      //       orgId: this.$attrs.orgId,
      //     },
      //   })
      //   .then((res) => {
      //     this.equipmentsPoints = res.data;
      //   });
      let current = 1,
        size = 10;
      let start = (current - 1) * size;
      let end = start + size <= this.equipmentIds.length ? start + size : this.equipmentIds.length;
      while (start < end) {
        let equipmentIds = this.equipmentIds.slice(start, end);
        const req = this.http.get('web/equipment/getMesMonitorData', {
          params: {
            orgId: this.$attrs.orgId,
            equipmentIdList: equipmentIds
          }
        });
        req.then(r => {
          Object.assign(this.equipmentsPoints, r.data);
          this.$forceUpdate();
        });
        current++;
        start = (current - 1) * size;
        end = start + size <= this.equipmentIds.length ? start + size : this.equipmentIds.length;
      }
    }
  }
};
</script>
